import { use } from 'react';
import {
  DENSITY_TOKENS,
  DensityContext,
  type DensityContextValue,
  type DensityTokens,
} from '@/theme/densityContext';

export function useDensity(): DensityContextValue {
  const context = use(DensityContext);
  if (!context) {
    throw new Error('useDensity must be used within a ColorModeProvider');
  }
  return context;
}

/** Spacing for the current density, for components that lay themselves out. */
export function useDensityTokens(): DensityTokens {
  return DENSITY_TOKENS[useDensity().density];
}
